<template>
  <div>
    <div class="hero">
      <div class="title ml-5 mt-5" style="z-index: +3; color: white"><b style="font-size: 40px;">Returns and Refunds Policy</b></div>
      <v-img src="@/assets/sky.jpg" height="150" />
    </div>
    <v-container>   
      <div v-for="Document in documents" :key="Document.id" >
        <div v-if="Document.name === 'Refund and Returns' ">
          <span v-html="Document.description"></span>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
	import {db} from '@/firebase';
	export default {
		name : "terms",
		props: {
      msg: String
    },
    data: () => ({
      documents: [],
      nav_title: 'Returns and Refunds',
    }),
    firestore() {
      return {
        documents: db.collection('documents')
      }
    }
	}
</script>

<style scoped>
  .title {
    position: absolute;
    top: 100px;
  }
</style>